export default {

    data () {
        return {
            checklistSets: []
        };
    },

    mounted () {
        let self = this;
        Bus.$on("checklist-created", function () {
            self.fetchChecklistSets();
        });
    },

    methods: {

        loadChecklistSets () {
            if (this.checklistSets.length <= 0) {
                this.fetchChecklistSets();
            }
        },

        fetchChecklistSets () {

            axios.get("/settings/inspections/checklists/all")
            .then(response => {
                this.checklistSets = response.data;
            })
            .catch(() => {
                toastr.error("Error loading checklist sets!");
            });

        }
    }

};